import axios from "axios";
import Swal from "sweetalert2";
import api from "./api_refresh_token";
import { isObject } from "formik";
import { Navigate, useNavigate } from "react-router-dom";
import { baseURL } from "./api_base";

axios.defaults.headers.common["Access-Control-Allow-Origin"] =
  "GET, POST, DELETE, PUT"; // definindo o que meu axios pode fazer

//Token
const getToken = () => {
  let token = localStorage.getItem("token");
  return token;
};

export const getCadastros = async (body, navigate, nomeEmpresa) => {
  try {
    const response = await api.post(`${baseURL}/empresa_store`, body, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
        "Content-Type": `multipart/form-data`,
      },
    });

    console.log("Response: ", response);
    const unidadeMatriz = response.data.unidadeMatriz;
    console.log("unidadeMatriz: ", unidadeMatriz);

    Swal.fire({
      icon: "success",
      title: "Empresa cadastrada com sucesso",
      text: `Um cadastro de unidade matriz foi criado com base no cadastro da empresa "${nomeEmpresa}". Isso é necessário, pois todos os cadastros de recursos do sistema (aplicações, solicitações, ordens de serviço etc.) são vinculados a uma unidade. Você pode alterar o cadastro da unidade a qualquer momento.`,
      confirmButtonText: "Editar unidade",
      cancelButtonText: "Continuar",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate(`/unidade-cadastrar`, { state: { id: unidadeMatriz.id } });
      }
    });

    return response;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const errors = error.response.data.errors;
      Swal.fire({
        icon: "error",
        title: isObject(errors) ? Object.values(errors)[0][0] : errors,
      });
    } else if (error.response && error.response.status === 500) {
      Swal.fire({
        icon: "error",
        title: "Erro interno do servidor",
        text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
      });
    } else {
      console.log(error);
    }
  }
};
/// buscar id's
export const getEmpresaById = (id) =>
  api
    .get(
      `${baseURL}/empresas/${id}`,

      // url base + rota de busca
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// PUT empresas

export const getUpdate = (id, body) =>
  api
    .post(
      `${baseURL}/empresa_update/${id}`,
      // url base + rota de busca
      body,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `multipart/form-data`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )
      Swal.fire({
        icon: "success",
        title: "Registro alterado com sucesso",
      });
      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });

// Delete

export const deleteEmpresa = (id) =>
  api
    .delete(
      `${baseURL}/empresa_delete/${id}`,
      // url base + rota de busca

      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": `application/json`,
        },
      }
    )
    .then((response) => {
      // promise ( resposta da requisição )

      return response;
    })
    .catch((error) => {
      if (error.response && error.response.status === 422) {
        const errors = error.response.data.errors;
        Swal.fire({
          icon: "error",
          title: isObject(errors) ? Object.values(errors)[0][0] : errors,
        });
      } else if (error.response && error.response.status === 500) {
        Swal.fire({
          icon: "error",
          title: "Erro interno do servidor",
          text: "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde.",
        });
      } else {
        console.log(error);
      }
    })
    .then(function (response) {
      return response;
    });
